import {twJoin} from 'tailwind-merge'

import {ResponsiveButton} from '../Button'

import type {SlideoutVariants} from './types'
import type {ButtonProps} from '../Button'

export interface SlideoutFooterProps {
  helper?: ButtonProps
  secondary?: ButtonProps
  primary: ButtonProps
  variant?: SlideoutVariants
}

export const SlideoutFooter = (props: SlideoutFooterProps) => {
  const {
    variant = 'crud-cufe',
    helper,
    primary,
    secondary,
  } = props

  const buttonSizes: Record<string, ButtonProps> = variant === 'crud-cufe' ? {
    small: {size: 'small'},
  } : {
    small: {
      className: 'inline-flex @[664px]:hidden',
      size: 'small',
    },
    medium: {
      className: 'hidden @[664px]:inline-flex',
      size: 'medium',
    },
  }

  return (
    <div
      className={twJoin(
        'bg-surface-primary',
        'flex items-center p-spacing-12 @[664px]:p-spacing-36 @[664px]:pt-spacing-12',
        helper ? 'justify-between' : 'justify-end',
      )}
    >
      {helper ? (
        <ResponsiveButton
          uniqueProps={buttonSizes}
          commonProps={{
            variant: 'flat',
            ...helper,
          }}
        />
      ) : null}
      <div className={'flex shrink items-center gap-spacing-12'}>
        {secondary ? (
          <ResponsiveButton
            uniqueProps={buttonSizes}
            commonProps={{
              variant: 'outline',
              ...secondary,
            }}
          />
        ) : null}
        <ResponsiveButton
          uniqueProps={buttonSizes}
          commonProps={{
            variant: 'filled-brand',
            ...primary,
          }}
        />
      </div>
    </div>
  )
}